/* iconMessageWrapper-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./iconMessageWrapper-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var breatheAnimation = null;
var animatedStyles = null;
var baseStyles = null;
export var IconMessageWrapper = function IconMessageWrapper(props) {
  var animated = props.animated;
  return /*#__PURE__*/React.createElement("div", {
    id: "iconMessageWrapper",
    className: ax(["_1reo15vq _18m915vq _1rjc1b66 _18zru2gc _tzy4kb7n _k48p1wq8 _syaz1e9r _y3gn1h6o _otyr1d21", animated && "", animated && "_j7hqq7op _5sag1nwe _1pgl1ytf _tip812c5"])
  }, props.children);
};